"use client";

import React from "react";
import Link from "next/link";
import styles from "./HostingMigrationSection.module.css";
import { hostingMigrationData as data } from "../../data/hosting";

export default function HostingMigrationSection() {
  const { eyebrow, title, subTitle, steps, highlights } = data;

  return (
    <section className={`py-5 ${styles.section}`}>
      <div className="container">
        <div className={`text-center mb-4`} data-reveal="fade">
          <span className={styles.eyebrow}>{eyebrow}</span>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.sub}>{subTitle}</p>
        </div>

        <div className={`row g-4`}>
          <div className="col-12 col-lg-7" data-reveal="stagger-up">
            <ol className={styles.timeline}>
              {steps.map((s, i) => (
                <li className={styles.step} key={s.title}>
                  <div className={styles.stepNum}>{i + 1}</div>
                  <div className={styles.stepBody}>
                    <h5 className={styles.stepTitle}>{s.title}</h5>
                    <p className={styles.stepText}>{s.description}</p>
                    <div className={styles.stepBadges}>
                      {s.badges?.map((b) => (
                        <span key={b} className={styles.badge}>
                          {b}
                        </span>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </div>
          <div className="col-12 col-lg-5" data-reveal="stagger-mix">
            <div className={styles.asideCol}>
              <div className={styles.asideGrid}>
                {highlights.map((h) => (
                  <div key={h.title} className={styles.asideTile}>
                    <div className={styles.asideIcon}>
                      <i className={h.icon} />
                    </div>
                    <div>
                      <h6 className={styles.asideTitle}>{h.title}</h6>
                      <p className={styles.asideText}>{h.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                className={styles.asideFooter}
                aria-label="Migration reliability metrics"
              >
                <div className={styles.metrics}>
                  <span className={styles.metric}>SLA 99.95%</span>
                  <span className={styles.metric}>RTO &lt; 5m</span>
                  <span className={styles.metric}>RPO &lt; 1m</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.cta} data-reveal="fade">
          <div>
            <p className={styles.ctaTitle}>Migrate with zero downtime</p>
            <p className={styles.ctaSub}>
              Book a free hosting assessment. We’ll map risks, set rollback
              plans, and schedule the switch.
            </p>
          </div>
          <Link
            href="/contact"
            className={styles.ctaBtn}
            aria-label="Book a free hosting assessment"
          >
            Get Free Assessment
          </Link>
        </div>
      </div>
    </section>
  );
}
